class FitmentChecker {
  constructor(config) {
    this.catalog = config.catalog;
    this.variantMap = config.variantMap;
    this.currentVariantId = config.initialVariantId;
    
    this.els = {
      year: document.getElementById('fitment-year'),
      make: document.getElementById('fitment-make'),
      model: document.getElementById('fitment-model'),
      submodel: document.getElementById('fitment-submodel'),
      length: document.getElementById('fitment-length'),
      roof: document.getElementById('fitment-roof'),
      driveline: document.getElementById('fitment-driveline'),
      axel: document.getElementById('fitment-axel')
    };
    this.msg = document.getElementById('fitment-msg');

    if (this.els.year && this.catalog) this.init();
  }

  init() {
    // Populate Initial Years
    const years = Object.keys(this.catalog).sort((a, b) => b - a);
    years.forEach(y => this.els.year.options.add(new Option(y, y)));

    // Event Listeners for cascading dropdowns
    this.els.year.addEventListener('change', () => {
      this.updateDropdown('make', Object.keys(this.catalog[this.els.year.value] || {}));
      this.resetDownstream(['model', 'submodel', 'length', 'roof', 'driveline', 'axel']);
    });

    this.els.make.addEventListener('change', () => {
      this.updateDropdown('model', Object.keys(this.catalog[this.els.year.value][this.els.make.value] || {}));
      this.resetDownstream(['submodel', 'length', 'roof', 'driveline', 'axel']);
    });

    this.els.model.addEventListener('change', () => {
      const data = this.catalog[this.els.year.value][this.els.make.value][this.els.model.value];
      if (data) {
        this.updateDropdown('submodel', data.submodels);
        this.updateDropdown('length', data.lengths);
        this.updateDropdown('roof', data.roofHeights);
        this.updateDropdown('driveline', data.drivelines);
        this.updateDropdown('axel', data.axelTypes);
      } else {
        this.resetDownstream(['submodel', 'length', 'roof', 'driveline', 'axel']);
      }
    });

    // Listen for any change to trigger the fitment check
    Object.values(this.els).forEach(el => {
      el.addEventListener('change', () => this.checkFitment());
    });

    // Listen for Shopify variant changes (e.g., user selects a different color/size)
    document.addEventListener('change', (e) => {
      // Common Shopify variant selectors: name="id" or classes like .variant-input
      if (e.target.name === 'id' || e.target.closest('.variant-input')) {
        this.currentVariantId = e.target.value;
        this.checkFitment();
      }
    });
  }

  updateDropdown(key, items) {
    const el = this.els[key];
    if (!el) return;
    
    // Set friendly labels for the "Select" option
    const labelMap = {
      roof: "Roof Height",
      axel: "Axle Type",
      driveline: "Driveline",
      submodel: "Sub-model"
    };
    const label = labelMap[key] || key.charAt(0).toUpperCase() + key.slice(1);
    
    el.innerHTML = `<option value="">Select ${label}</option>`;
    
    if (items && items.length) {
      el.disabled = false;
      items.sort().forEach(i => el.options.add(new Option(i.trim(), i.trim())));
    } else {
      el.disabled = true;
    }
  }

  resetDownstream(keys) {
    keys.forEach(k => {
      const el = this.els[k];
      if (el) {
        const labelMap = { roof: "Roof Height", axel: "Axle Type" };
        const label = labelMap[k] || k.charAt(0).toUpperCase() + k.slice(1);
        el.innerHTML = `<option value="">Select ${label}</option>`;
        el.disabled = true;
      }
    });
    this.checkFitment();
  }

  checkFitment() {
    const selected = {
      year: this.els.year.value,
      make: this.els.make.value,
      model: this.els.model.value,
      submodel: this.els.submodel.value,
      length: this.els.length.value,
      roofHeight: this.els.roof.value,
      driveline: this.els.driveline.value,
      axelType: this.els.axel.value
    };

    // ONLY show result if ALL 8 properties are selected
    const allFieldsFilled = Object.values(selected).every(val => val !== "");

    if (!allFieldsFilled) {
      this.msg.style.display = 'none';
      return;
    }

    const fitmentList = this.variantMap[this.currentVariantId] || [];
    
    // Matching Logic: If a metadata property is missing/blank, it's a wildcard (fits all)
    const isFit = fitmentList.some((metaEntry) => {
      return Object.keys(selected).every(key => {
        const userVal = String(selected[key]).trim().toLowerCase();
        const metaVal = metaEntry[key] ? String(metaEntry[key]).trim().toLowerCase() : "";

        // If metadata doesn't define this key (e.g., no "submodel"), it fits ALL submodels
        if (metaVal === "" || metaVal === "all") return true;

        // If metadata DOES define it, it must match the user selection
        return metaVal === userVal;
      });
    });

    // Display the Result
    this.msg.style.display = 'block';
    if (isFit) {
      this.msg.className = 'fitment-result fit-success';
      this.msg.textContent = "✅ Fits your vehicle";
    } else {
      this.msg.className = 'fitment-result fit-error';
      this.msg.textContent = "❌ Does not fit this configuration";
    }
  }
}